import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { APIResponse, BasicResponse } from '../_types/api-responses.types';
import { Admin } from '../_types/auth.types';
import {
  AssignCustomerSupportRequest,
  AssignCustomerSupportResponse,
  CustomerSupportAssignableEntities,
  CustomerSupportsOfPartnerRequest,
  CustomerSupportsOfPartnerResponse,
  DeleteCustomerSupportResponse,
} from '../_types/customer-support.types';
import { Partner } from '../_types/partner.type';
import { UserAuthService } from './user-auth.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerSupportService {
  private baseUrl: string;

  private insuranceBaseUrl: string;

  private baseHeaders = new HttpHeaders().set(
    'content-type',
    'application/json'
  );

  constructor(
    private httpClient: HttpClient,
    private userAuthService: UserAuthService
  ) {
    this.baseUrl = `${environment.USERAPIENDPOINT}admin/`;
    this.insuranceBaseUrl = environment.INSURANCEAPIURL;
  }

  get headersWithToken(): HttpHeaders {
    return this.baseHeaders.set(
      'Access-Token',
      this.userAuthService.getCurrentUser().token
    );
  }

  getCustomerSupportsOfPartner(
    request: CustomerSupportsOfPartnerRequest
  ): Observable<CustomerSupportsOfPartnerResponse> {
    return this.httpClient.post<CustomerSupportsOfPartnerResponse>(
      `${this.baseUrl}get/customer-supports-of-partner`,
      request,
      {
        headers: this.headersWithToken,
      }
    );
  }

  getPartnerOfCustomerSupports(
    customerSupportId: string
  ): Observable<APIResponse<{ agentsList: Partner[] }>> {
    return this.httpClient.post<APIResponse<{ agentsList: Partner[] }>>(
      `${this.baseUrl}get/partners-of-customer-support/details`,
      { customerSupportId },
      {
        headers: this.headersWithToken,
      }
    );
  }

  assignCustomerSupport(
    request: AssignCustomerSupportRequest
  ): Observable<AssignCustomerSupportResponse> {
    return this.httpClient.post<AssignCustomerSupportResponse>(
      `${this.baseUrl}add/assign-customer-support-partner`,
      request,
      {
        headers: this.headersWithToken,
      }
    );
  }

  deleteCustomerSupport(id: number): Observable<DeleteCustomerSupportResponse> {
    return this.httpClient.post<DeleteCustomerSupportResponse>(
      `${this.baseUrl}delete/customer-support-partner`,
      {
        id,
      },
      {
        headers: this.headersWithToken,
      }
    );
  }

  assignCustomerSupportToElement(
    customerSupportId: string,
    elementId: string,
    entityType: CustomerSupportAssignableEntities
  ): Observable<APIResponse<BasicResponse>> {
    return this.httpClient.post<APIResponse<BasicResponse>>(
      `${this.insuranceBaseUrl}assign/customer-support/${entityType}`,
      {
        entityId: customerSupportId,
        elementId,
      },
      {
        headers: this.headersWithToken,
      }
    );
  }

  getCustomerSupportList(): Observable<
    APIResponse<{ customerSupportAgentsList: Admin[] }>
  > {
    return this.httpClient.get<
      APIResponse<{ customerSupportAgentsList: Admin[] }>
    >(`${this.baseUrl}get/csa`, {
      headers: this.headersWithToken,
    });
  }

  getActiveCustomerSupportList(): Observable<
    APIResponse<{ customerSupportAgentsList: Admin[] }>
  > {
    return this.httpClient.get<
      APIResponse<{ customerSupportAgentsList: Admin[] }>
    >(`${this.baseUrl}get/csa/active`, {
      headers: this.headersWithToken,
    });
  }

  getGroupeMutuelCustomerSupportList(): Observable<
    APIResponse<{ customerSupportAgentsList: Admin[] }>
  > {
    return this.httpClient.get<
      APIResponse<{ customerSupportAgentsList: Admin[] }>
    >(`${this.baseUrl}get/csa/groupe-mutuel`, {
      headers: this.headersWithToken,
    });
  }
}
